import { Tab, Tabs } from '@mui/material'
import { useAppSelector } from '@SonarCX/hooks/redux'
import { AnimatePresence, motion } from 'framer-motion'
import React from 'react'

import TaskMultiEdit from '@SonarCX/components/organisms/TaskMultiEdit'
import ActionButton from '../../components/organisms/ActionButton'
import AgentPage from '../../components/templates/AgentPage'

import TaskCommentsPreviewModal from '@SonarCX/components/atoms/TaskCommentsPreviewModal'
import { useTaskComments } from '@SonarCX/providers/TaskCommentsProvider'
import { selectAllTasksTable } from '@SonarCX/slices/allTasksTable'
import { useBreakpoint } from '../../providers/BreakpointProvider'
import {
  ALL_TAB,
  CARDS_TAB,
  TABS,
  useTaskPageState
} from '../../providers/TaskPageStateProvider'
import useStyles from './styles'

const TabPanel = ({ value, index, children }) => {
  if (value !== index) {
    return null
  }

  return children
}

const Tasks = () => {
  const { selected } = useAppSelector(selectAllTasksTable)

  const { tab, setTab } = useTaskPageState()
  const { isSmall, isMedium } = useBreakpoint()
  const { viewingTaskCommentsID, setViewingTaskCommentsID, setHasModalWithComments, shouldCheckClose, setShouldCheckClose } = useTaskComments()

  const pageRef = React.useRef()
  const [showTabs, setShowTabs] = React.useState(true)

  const classes = useStyles()

  const handleHideCommentPreview = React.useCallback(() => {
    setHasModalWithComments(false)
    setViewingTaskCommentsID(null)
    setShouldCheckClose && setShouldCheckClose(false)
  }, [setHasModalWithComments, setViewingTaskCommentsID, setShouldCheckClose])

  return (
    <>
      <AgentPage rootRef={pageRef} scroll={![ALL_TAB, CARDS_TAB].includes(tab)}>
        <div className={classes.root}>
          {tab !== CARDS_TAB && selected.length > 0 ? (
            <TaskMultiEdit />
          ) : (
            showTabs && (
              <AnimatePresence>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 1 }}
                >
                  <Tabs
                    value={tab}
                    onChange={(_, val) => setTab(val)}
                    variant={isMedium ? 'fullWidth' : 'standard'}
                    className={classes.tabs}
                  >
                    <Tab label='Overview' classes={{ root: classes.tab }} />

                    <Tab label='Categories' classes={{ root: classes.tab }} />

                    <Tab label='All Tasks' classes={{ root: classes.tab }} />

                    <Tab label='Cards' classes={{ root: classes.tab }} />
                  </Tabs>
                </motion.div>
              </AnimatePresence>
            )
          )}

          {TABS.map((Comp, i) => (
            <TabPanel key={i} value={tab} index={i}>
              <Comp pageRef={pageRef} tabState={[showTabs, setShowTabs]} />
            </TabPanel>
          ))}
        </div>
      </AgentPage>

      {Boolean(viewingTaskCommentsID) &&
        <TaskCommentsPreviewModal
          onClose={handleHideCommentPreview}
          parentRef={{
            current: {
              getBoundingClientRect: () => {
                const id = `task-comments-${viewingTaskCommentsID}`
                const element = document.getElementById(id)

                if (!element) {
                  return { top: 0, left: 0, width: 400, height: 400 }
                }

                return element.getBoundingClientRect()
              }
            }
          }}
          taskId={viewingTaskCommentsID}
          shouldCheckClose={shouldCheckClose}
        />
      }

      {!isSmall && <ActionButton screen='task' tab={tab} />}
    </>
  )
}

export default Tasks
